import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import {
  VirtualCareState,
  VirtualCareStoreKeys,
  initialVirtualCareState,
} from './virtualCareStore';

const store = (set): VirtualCareState => ({
  ...initialVirtualCareState,
  [VirtualCareStoreKeys.ELIGIBILITIES]: {},
  [VirtualCareStoreKeys.SET_ELIGIBILITIES]: (planToken, eligibilities) =>
    set((state) => ({
      eligibilities: {
        ...state.eligibilities,
        [planToken]: eligibilities ?? {},
      },
    })),
  [VirtualCareStoreKeys.CLEAR_ELIGIBILITIES]: (planContextIds) => {
    const planTokens = planContextIds?.split(':');
    set((state) => ({
      eligibilities: clearEligibilitiesByTokens(planTokens, state),
    }));
  },
  [VirtualCareStoreKeys.VIRTUAL_CARE_PROVIDERS]: [],
  [VirtualCareStoreKeys.SET_VIRTUAL_CARE_PROVIDERS]: (providers) =>
    set(() => ({
      virtualCareProviders: providers ?? [],
    })),
});

const clearEligibilitiesByTokens = (planTokens, state) => {
  const newEligibilities = {};
  planTokens?.forEach((token) => {
    newEligibilities[token] = state.eligibilities[token];
  });
  return newEligibilities;
};

const virtualCareStore = persist(store, {
  name: 'virtualCareStore',
  storage: createJSONStorage(() => sessionStorage),
});

export const useVirtualCareStore = create(devtools(virtualCareStore));
